import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonLoader = ({ height = 50, count = 1 }) => {
  return <Skeleton height={height} count={count} />;
};

export default SkeletonLoader;
